<template>
  <div
    :class="['base-info',  { 'has-btn': offline_offsite }, { 'has-guarantee': banner_config && has_reward_banner }, `${page_style}`]"
  >
    <div v-for="(item, idx) in form" :key="idx" :class="[item.type]">
      <component
        :is="getCom(item)"
        :form-item="item"
        :idx="idx"
        :linked_val="link_other_com"
        :ob_driver_id="ob_driver_id"
        :page_style="page_style"
        @form-update="formUpdate"
        v-show="item.type !== 'select_county' || (item.type === 'select_county' && item.is_linked === true && item.citys.split(',').includes(_area.value && _area.value.toString()))"
      ></component>
    </div>
    <div :class="{ 'btn-wraper': 1, 'btn-bottom': offline_offsite }">
      <p v-if="offline_offsite" class="text-link">
        <span @click="showSite">{{ offline_offsite.title }}</span>
      </p>
      <input
        v-show="inited"
        type="button"
        :class="['btn-info-submit', { 'btn-info-active': validForm }, { [`btn-info-active-${location_country}`] : validForm }]"
        :value="submit_btn.title || $t('提交')"
        :disabled="!validForm"
        @click="submitInfo('submit')"
      />
      <div v-if="has_reward_banner && banner_config" class="guarantee-banner">
        <img-txt-link
          :form-item="banner_config"
          v-if="banner_config.type === 'img-txt-link'"
        ></img-txt-link>
      </div>
    </div>
    <offline-site
      ref="offlineSite"
      :config="offline_offsite || {}"
    ></offline-site>
    <div class="bg-mask" v-if="confirmDialog"></div>
    <div class="base-info-close-foot" v-if="confirmDialog">
      <div class="close-foot-text">
        <div class="close-foot-content">{{submit_btn.submit_tip || submit_tip || $t("确认提交吗？")}}</div>
        <img
          :src="require('../images/icon_close.png')"
          alt=""
          class="close"
          @click="close"
        />
      </div>
      <div class="close-foot-btn">
        <div class="foot-btn quit" @click="close">{{$t("取消")}}</div>
        <div :class="['foot-btn', 'confirm', `confirm-${location_country}`]" @click="confirm">{{$t("确认")}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../tools/request";
import { showDialog, showAlertDialog, showLoadingToast } from "../tools/Tip";
import { setTitle } from "../tools/setTitle";
import { ends, AREA_TYPE } from "../tools/constant";
import {
  formatCPFBr,
  formatAccent,
  formatCURPMx,
  formatRUT,
  formatCURPCr,
  formatCNPJBr,
  fireBase,
  computeJumpTime,
  computeStayTime
} from "../tools/utils";
import Banner from "./base/Banner";
import OfflineSite from "./base/offline-site";
import TextLink from "./base/text-link";
import Input from "./base/Input";
import DrawerCity from "./base/drawer-city";
import DrawerCityPage from "./base/drawer-city-page";
import DatePicker from "./base/date-picker";
//默认单行选择
import DefaultSelect from "./base/default-select";
import ImgTxtLink from "./base/img-txt-link.vue";
import HomeBanner from "./loginComp/home-banner.vue";


//todo notes 初始化form时，赋值，valid，解决不触发双向绑定的问题
export default {
  name: "baseInfo",
  components: {
    Banner,
    TextLink,
    Input,
    DrawerCity,
    DrawerCityPage,
    DefaultSelect,
    OfflineSite,
    ImgTxtLink,
    HomeBanner
  },
  computed: {
    ...mapState([
      "_ticket",
      "_identity",
      "_area",
      "_open_type",
      "_city",
      "_city_open_type",
      "_uuid",
      "_product",
      "_mx_id_no_ab_test",
      "_landing_H5_1110",
      "_page_stay_time",
      "_page_jump_time",
      "_route_path"
      // "_auto_submit"
    ]),
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      const query = new URLSearchParams(location.search);
      return query.get("location_country");
    },
    country_text() {
      const query = new URLSearchParams(location.search);
      let o = {
        BR: {
          showDialogtitle: this.$t("GRider_Track_minutes_to_dNjh").replace(
            /{{carona_name}}/,
            this.$t("GRider_Track_Brazilian_Hitch_VklT")
          ),
          content: this.$t("GRider_Track_You_are_lqKw")
            .replace(
              /{{pop_name}}/,
              this.$t("GRider_Track_Brazilian_Express_BxFj")
            )
            .replace(
              /{{carona_name}}/,
              this.$t("GRider_Track_Brazilian_Hitch_VklT")
            ),
        },
        CL: {
          showDialogtitle: this.$t("GRider_Track_1_minute_iDqx").replace(
            /{{brand_name}}/,
            this.$t("GRider_brandname_Hitch_jwYK")
          ),
          content: this.$t("GRider_Track_You_are_nlRj")
            .replace(/{{express_name}}/, this.$t("simple_name||mexico_fast"))
            .replace(/{{brand_name}}/, this.$t("GRider_brandname_Hitch_jwYK")),
        },
      };
      return o[query.get("location_country")] || o.BR;
    },
    //检查form中每一项正确性,所有form 的input、select 项必须valid为true
    //20200318 linked以及this.link_other_com均存在,表示会受其他组件关联，可能为为非必填项
    // 20211123 墨西哥id_no后置实验, 组件中有hide参数已经实验接口返回true,代表id_no项不填
    validForm() {
      let needCheck;
      if(this.form.some(item => item.type === 'select_county') && this.form.filter(item => item.type === 'select_county')[0].citys.split(',').includes(this._area.value && this._area.value.toString())) {
        needCheck = ["input", "select", "date", "select_county"];
        if (!this._city.value) {
          this.form.filter(item => item.type === 'select_county')[0].valid = false;
        }
      } else {
        needCheck = ["input", "select", "date"];
      }
      return this.form
        .filter((x) => needCheck.includes(x.type))
        .every(
          (x) =>
            x.valid ||
            (this.link_other_com &&
              x.linked &&
              x.linked !== this.link_other_com) ||
            (x.required !== undefined && !x.required) ||
            (x.hide && this._mx_id_no_ab_test)
        );
    },
    offline_offsite() {
      return this.form.find((item) => item.type === "button_offline");
    },
    link_other_com() {
      let com = this.form.find((item) => item.link_other_com) || {};
      return com.value;
    },
    submit_btn() {
      return (
        this.form.find(
          (item) => item.type === "button" && item.align === "bottom"
        ) || {}
      );
    },
    has_guarantee_city() {
      return this.city_guarantee_list[this._area.value] || false;
    },
    has_reward_banner() {
      return this.has_guarantee_city.is_show_banner&& this.banner_config.img_url|| false;
    },
    banner_config() {
      if (!this.has_guarantee_city) {
        return false;
      }
      let banner_config = { ...this.has_guarantee_city.basic_page_reward_banner };
      let text = banner_config.title || "";
      if (this.has_guarantee_city) {
        let rides_reward =
          (this.has_guarantee_city.rides_reward || []).pop() || {};
        banner_config.title = text
          .replace(/\{\{city\}\}/, this.has_guarantee_city.areaName || "")
          .replace(/\{\{fee_amount\}\}/, rides_reward.reward || "");
      } 
      // else {
      //   banner_config = this.has_guarantee_city.passport_default_reward_banner;
      // }
      return banner_config;
    },
    omegaItem() {
      return {
        channel: this.params.get("channel") || "",
        oid: this.params.get("oid") || Omega.getOmgid(),
        identity_id: this._identity,
        product_id: this._product,
        driver_id: this.ob_driver_id,
      };
    },
    end() {
      let up = new URLSearchParams(window.location.search);
      return up.get("end");
    },
    isPreviewPage() {
      let up = new URLSearchParams(location.search);
      return up.get('ob_page_type') === 'preview';
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
  },
  watch: {
    validForm(newV) {
      this.$emit("btn-update");
      if (this.is_treatment_group && newV) {
        this.submitInfo();
      }
    },
    _area: {
      handler(newV, oldV) {
        let oldArea = oldV ? oldV.value : "";
        if (newV.value && !oldArea && this._product == 2) {
          // @20210621 新人保底奖基础信息页透传,只有快车
          // @20210629 第一次取到城市的时候获取实验接口，后续改动城市不请求
          this.getCityBanner();
        }
        if (newV.value && this._product == 2) {
          // @20211123 墨西哥id_no后置实验,只在墨西哥城做,所以需要选完城市后调用实验接口
          this.mxIdNoAB();
        }
      },
      deep: true,
      immediate: true, //页面初始化时立即调用
    },
  },
  data() {
    return {
      inited: false,
      is_treatment_group: false,
      form: [],
      submit_tip: "",
      passport_reward_banner: {},
      city_guarantee_list: {},
      ob_driver_id: '',
      page_style: "", // 各渠道&新老funnel样式控制
      confirmDialog: false,
    };
  },
  methods: {
    ...mapMutations(["setState"]),
    formatCPFBr,
    formatAccent,
    formatCURPMx,
    formatRUT,
    formatCURPCr,
    formatCNPJBr,
    getPageConfig() {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (this._identity) {
        up.set("identity", this._identity);
      }
      if (this.isPreviewPage) {
        up.set("page", 'jobs_basic_conf');
      }
      let BASEINFO_URL = this.isPreviewPage ? process.env.BASEINFO_URL_PRE : process.env.BASEINFO_URL
      post(BASEINFO_URL, up)
        .then((data) => {
          this.page_style = data.page_style || ''; ///暂时 无接口mock
          this.form = data.form;
          this.submit_tip = data.submit_tip;
          // @20230818 产品需求去掉自动提交的逻辑
          // this.is_treatment_group = data.is_treatment_group;
          this.inited = true;
          this.ob_driver_id = data.onboarding_driver_id;
          data.title && setTitle(data.title);

          // @20221117 新提交button的埋点
          try {
            Omega.trackEvent("ibt_onboarding_info_sw", "", {
              ...this.omegaItem,
            });
          } catch (e) {}
        })
        .catch((err) => {
          showAlertDialog(this);
          try {
            Omega.trackEvent("ibt_register_basic_information_form_configuration_error_ck", '', {
              path_url: BASEINFO_URL,  //接口url
              message: JSON.stringify(err),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: err.errno,  //报错码
            });
          } catch (e) {}
        })
        .finally(() => {
          this.toast.hide();
        });
    },
    checkquickimport() {
      let up = new URLSearchParams(window.location.search);
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      //判断是否进入可fasttrap流程
      this.dialog && this.dialog.hide();
      post(process.env.FASTTRAP_SHOW, up)
        .then((data) => {
          if (data.result !== false) {
            showDialog(this, {
              type: "confirm",
              title: this.country_text.showDialogtitle,
              content: this.country_text.content,
              confirmBtn: {
                text: this.$t("GRider_Track_Sync_now_RVJm"),
              },
              cancelBtn: { text: this.$t("GRider_Track_No_thank_HzoZ") },
              onConfirm: () => {
                this.handleSubmit(data.ticket);
              },
              // onCancel: () => {
              //   Omega.trackEvent("toggle_CNH_update_popup_no");
              // }
            });
          }
        })
        .catch((err) => {
          // 报错不做任何弹窗
          showAlertDialog(this);
        });
    },
    close() {
      this.confirmDialog = false;
      document.body.style.overflow = 'visible';
      Omega.trackEvent("gd_oasisCPFconfirm_cancel_btn_ck");
    },
    confirm() {
      this.confirmSubmit();
      this.confirmDialog = false;
      document.body.style.overflow = 'visible';
    },
    //接收各组件发送的更新emit
    formUpdate(idx) {
      this.$set(this.form, idx, this.form[idx]);
      this.$emit("btn-update");
    },
    submitInfo(type) {
      if (this.validForm) {
        // @20221117 新注册的曝光埋点
        try {
          Omega.trackEvent("ibt_onboarding_submit_ck", "", {
            ...this.omegaItem,
          });
        } catch (e) {}

        this.confirmDialog = true;
        document.body.style.overflow = 'hidden';
        // showDialog(this, {
        //   type: "confirm",
        //   icon: "cubeic-info",
        //   content:
        //     this.submit_btn.submit_tip ||
        //     this.submit_tip ||
        //     this.$t("确认提交吗？"),
        //   confirmBtn: { text: this.$t("确认") },
        //   cancelBtn: { text: this.$t("取消") },
        //   onConfirm: this.confirmSubmit,
        //   onCancel: () => {
        //     Omega.trackEvent("gd_oasisCPFconfirm_cancel_btn_ck");
        //   },
        // });
      }
    },
    confirmSubmit() {
      // showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let identity_item = false;
      //兼容global，driver_role选择的case
      if (this._identity) {
        up.set("identity", this._identity);
      }
      this.form.forEach((x) => {
        if (x.key) {
          //检测是否需要清除格式
          let val = x.value;
          if (x.clear_format) {
            val = this[x.format](val, true);
          }
          if (!up.get(x.key) || x.key === 'identity') {
            up.set(x.key, val);
          }
        }
      });
      if (this._area.value && this._open_type && !up.get(this._open_type)) {
        up.set(this._open_type, this._area.value);
      }
      if (this._city.value && this._city_open_type) {
        up.set(this._city_open_type, this._city.value);
      }
      if (this.form.some(item => item.type === 'select_county') && !this._city.value) {
        const key = this.form.filter(item => item.type === 'select_county')[0].key;
        up.delete(key);
      }
      post(process.env.ADD_BASE_INFO, up)
        .then((data) => {
          // 由路由控制下一步，进入证件列表页
          this.$router.replace({ name: "home" });
          try {
            Omega.trackEvent("gd_driverMesSubmit_btn_ck", "", {
              appsflyer_uid: new URLSearchParams(window.location.search).get(
                "appsflyer_uid"
              ),
              ibt_crm_uid: this.ob_driver_id,
              client_user_agent: navigator.userAgent, // 必须
              // client_ip_address: '', // 可选
              fbp: this.$cookies.get('_fbp'), // 可选，可能有多个，需要和domain匹配
              fbc: this.$cookies.get('_fbc'), // 可选，可能有多个或没有，需要和domain匹配
            });
            gtag_report_conversion();
            fbq("track", "CompleteRegistration", {eventID: Omega.getOmgid()});
            snaptr('track', 'START_TRIAL', {eventID: Omega.getOmgid()});
            fireBase("gd_driverMesSubmit_btn_ck");
            gtm({ event: "s6ObSignup", error: "false" });
          } catch (e) {
            console.log(" error", e);
          }
        })
        .catch((res) => {
          showAlertDialog(this, res.errmsg);
          gtm({ event: "s6ObSignup", error: "true" });
          try {
            Omega.trackEvent("ibt_register_submit_basic_information_error_ck", '', {
              path_url: process.env.ADD_BASE_INFO,  //接口url
              message: JSON.stringify(res),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: res.errno,  //报错码
            });
          } catch (e) {}
        })
        .finally((x) => this.toast.hide());
    },
    showSite() {
      if (this.offline_offsite.target == "blank") {
        location.href = this.offline_offsite.link;
        return;
      }
      this.$refs.offlineSite.getLineSite();
      this.$refs.offlineSite.show();
    },
    getCom(item) {
      if (Object.keys(AREA_TYPE).includes(item.type)) {
        if (item.align == "right") {
          //@20190925 调整为整页打开
          return "DrawerCityPage";
          // return "DrawerCity";
        }
        return "DefaultSelect";
      }
      return {
        banner: Banner,
        input: Input,
        "text-link": TextLink,
        date: DatePicker,
        "rotation-banner": HomeBanner,
      }[item.type];
    },
    handleSubmit(ticket) {
      let up = new URLSearchParams(location.search);
      let vamos_ticket;
      if (this._ticket) {
        vamos_ticket = this._ticket;
      } else if (up.get("ticket")) {
        vamos_ticket = up.get("ticket");
      } else if (up.get("token")) {
        vamos_ticket = up.get("token");
      }
      up.set("vamos_ticket", vamos_ticket);
      up.set("ticket", ticket);
      if (ends.isPassengerTerminal) {
        up.set("passengerduan", "in");
      } else {
        up.set("passengerduan", "out");
      }
      up.set("vamos_end", "passenger"); // 新增 vamos_end=passenger 表示来自乘客端注册
      location.replace(
        `https://page.didiglobal.com/driver-page/toVamos/index.html?product=13&${up}#/confirm`
      );
    },
    getCityBanner() {
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      up.set("areaId", this._area.value);
      post(process.env.BASE_BANNER_INFO,up)
        .then((res) => {
          console.log(res.reward_conf,'test');
          this.city_guarantee_list = res.reward_conf || {};
          // this.has_reward_banner = this.has_guarantee_city.is_show_banner;
          // console.log(this.has_reward_banner,909090)
          // if (res.is_show_banner && res.passport_reward_banner) {
          //   this.passport_reward_banner = { ...res.passport_reward_banner };
          //   this.passport_default_reward_banner = {
          //     ...res.passport_default_reward_banner,
          //   };
          // }
          // this.banner_config = data.passport_reward_banner || {};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    mxIdNoAB() {
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      up.set("areaId", this._area.value);
      post(process.env.MX_ID_NO_AB_TEST, up)
        .then((res) => {
          this.setState({ _mx_id_no_ab_test: res.is_hide, }); //更新vuex
        })
        .catch((err) => {
          Omega.trackError("tech_ibt_growth_ajax_error_bt", err.errno, err.errmsg, {
            url: process.env.MX_ID_NO_AB_TEST,
            resp: err,
            desc: '墨西哥id_no实验接口报错',
            page: 'register'
          });
          Omega.trackEvent("tech_ibt_growth_ajax_error_bt", err.errno, err.errmsg, {
            url: process.env.MX_ID_NO_AB_TEST,
            resp: err,
            desc: '墨西哥id_no实验接口报错',
            page: 'register'
          });
        });
    }
  },
  beforeDestroy () {
    clearTimeout(this.importtime);
    try {
      computeStayTime(this)
    } catch (error) {}
  },
  beforeCreate() {
    //一旦进入基础信息页，返回按钮需要正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  mounted() {
    window._t = this;
    //解决，页面刷新时，多次请求的bug，旧的作用域已不存在，所以不会触发fn
    setTimeout(this.getPageConfig, 0);
    let up = new URLSearchParams(location.search);
    //20200228 vamos设置返回拦截
    if (ends.isPassengerTerminal && up.get("business_line") === "oasis") {
      Fusion.interceptGoback &&
        Fusion.interceptGoback(
          {
            needs_intercept: true,
            intercept_style: 1,
            intercept_model: {
              title: this.$t(
                "Global_Rider_Oasis_on_boarding0104_GlobalRider_Certification_owner_ixFB"
              ),
              subtitle: this.$t(
                "Global_Rider_Oasis_on_boarding0104_GlobalRider_Fill_in_ISdI"
              ),
              confirm_btn_title: this.$t(
                "Global_Rider_Oasis_on_boarding0104_GlobalRider_Exit_TVIb"
              ),
              cancel_btn_title: this.$t(
                "Global_Rider_Oasis_on_boarding0104_GlobalRider_Certification_continue_KzyL"
              ),
            },
            omega_config: {
              sw_event: "gd_vamosExitregister_view_sw",
              confirm_ck_event: "gd_vamosExitregister_continue_ck",
              cancel_ck_event: "gd_vamosExitregister_back_ck",
              params: { type: "CPF" },
            },
          },
          () => {}
        );
    }

    //顺风车端外 询问是否进入fasttrack
    if (up.get("business_line") === "oasis") {
      this.importtime = setTimeout(this.checkquickimport, 0);
    }
    try {
      Omega.trackEvent("tone_p_x_email_sw");
      Omega.trackEvent("gd_driverMes_view_sw");
    } catch (e) {}
    try {
      computeJumpTime(this)
    } catch (error) {}
  },
};
</script>

<style lang="scss" scoped>
.btn-wraper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0.43rem 0.31rem;
}
.btn-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
}
.has-guarantee {
  padding-bottom: 4.68rem;
}
.guarantee-banner {
  width: 100%;
  height: 1.68rem;
  margin-top: 0.8rem;
  .img-container {
    margin: 0;
  }
}
.base-info.h5_funnel_fleet {
  min-height: 100vh;
  padding-bottom: 1.8rem;
  box-sizing: border-box;
  background: #fff;
  &.has-btn {
    padding-bottom: 2.4rem;
  }
  &.has-guarantee.has-btn {
    padding-bottom: 4.8rem;
  }
  .btn-wraper {
    margin: 0;
    padding: 0.32rem;
    position: fixed;
    bottom: 0;
    left: 0;
    box-shadow: 0px -20px 20px 0px rgba(0,0,0,0.06);
    background: #ffffff;
    .btn-info-submit {
      background: #E9ECEE;
      border-radius: .2rem;
      font-size: .4rem;
      color: #999999;
      text-align: center;
      font-weight: 700;
      &.btn-info-active {
        background-image: linear-gradient(145deg, #FF7D41 0%, rgba(255,116,15,0.75) 99%);
        color: #FFFFFF;
      }
      &.btn-info-active-BR {
        background-image: linear-gradient(-46deg, #FFAE1E 0%, #FFCA00 100%);
        color: #333333;
      }
    }
  }
}
.base-info.h5_funnel_fleet_pc {
  padding: 0 48px;
  background: #fff;
  .rotation-banner {
    width: calc(100% + 96px);
    margin-left: -48px;
  }
  .btn-wraper {
    position: relative;
    margin: 64px 32px;
    padding-bottom: 100px;
    .btn-info-submit {
      width: 100%;
      height: 52px;
      background: #E9ECEE;
      border-radius: 10px;
      font-size: 20px;
      color: #999999;
      font-weight: 700;
      &.btn-info-active {
        background-image: linear-gradient(145deg, #FF7D41 0%, rgba(255,116,15,0.75) 99%);
        color: #FFFFFF;
      }
      &.btn-info-active-BR {
        background-image: linear-gradient(-46deg, #FFAE1E 0%, #FFCA00 100%);
        color: #333333;
      }
    }
  }
}
.base-info-close-foot {
  position: fixed;
  z-index: 999;
  bottom: 0;
  width: 100%;
  padding: 0.32rem 0.32rem;
  box-sizing: border-box;
  color: #91a0b4;
  background: #ffffff;
  border-radius: 0.3rem 0.3rem 1px 1px;
  .close-foot-text {
    color: #000;
    font-size: 0.4rem;
    font-weight: bold;
    position: relative;
    .close-foot-content {
      width: 90%;
      display: inline-block;
    }
    .close {
      width: 0.48rem;
      position: absolute;
      top: 0;
    }
  }
  .close-foot-btn {
    display: flex;
    justify-content: space-between;
    .foot-btn {
      margin-top: 0.9rem;
      width: 3.1rem;
      height: 1rem;
      line-height: 1.08rem;
      border-radius: 0.12rem;
      text-align: center;
      font-size: 0.36rem;
      font-weight: bold;
    }
    .quit {
      border: 1px #666 solid;
      color: #666;
    }
    .confirm {
      background: rgb(255, 114, 38);
      color: #fff;
    }
    .confirm-BR {
      background: #FFDB16;
      color: #333;
    }
  }
}
.bg-mask {
  position: fixed;
  z-index: 998;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(15,25,40, 0.6);
}
</style>
